import { MESSAGE } from "../apiConstant";
import BaseApi from "../baseApi";

class MessageApi extends BaseApi {
  getList(param, signal) {
    return this.post(`${MESSAGE}/conversation/message`, param, signal);
  }

  getTargetMessage(param, signal) {
    return this.post(`${MESSAGE}/conversation/quote`, param, signal);
  }

  sendMessage(request) {
    try {
      return this.post(`${MESSAGE}/send`, request);
    } catch (e) {
      console.error("Send message fail: " + e);
    }
  }

  schedule(request) {
    try {
      return this.post(`${MESSAGE}/schedule`, request);
    } catch (e) {
      console.error("Send message fail: " + e);
    }
  }

  deleteSchedule(request) {
    try {
      return this.post(`${MESSAGE}/delete-schedule`, request);
    } catch (e) {
      console.error("Send message fail: " + e);
    }
  }

  sendFileChunk(request) {
    try {
      return this.post(`${MESSAGE}/send`, request);
    } catch (e) {
      console.error("Send message fail: " + e);
    }
  }

  shareMessageByConversationId(request) {
    try {
      return this.post(`${MESSAGE}/share`, request);
    } catch (e) {
      console.error("Share message fail: " + e);
    }
  }

  shareMessageByUserId(request) {
    try {
      return this.post(`${MESSAGE}/user-share`, request);
    } catch (e) {
      console.error("Share message fail: " + e);
    }
  }

  cancelMessage(request) {
    try {
      return this.post(`${MESSAGE}/cancel`, request);
    } catch (e) {
      console.error("cancel message fail: " + e);
    }
  }

  removeMessage(request) {
    try {
      return this.post(`${MESSAGE}/remove`, request);
    } catch (e) {
      console.error("Remove message fail: " + e);
    }
  }

  reactionMessage(request) {
    try {
      return this.post(`${MESSAGE}/reaction`, request);
    } catch (e) {
      console.error("Reaction message fail: " + e);
    }
  }

  commentReply(request) {
    try {
      return this.post(`${MESSAGE}/comment`, request);
    } catch (e) {
      console.error("Comment message fail: " + e);
    }
  }

  uploadChunk(req) {
    return this.post(`${MESSAGE}/upload-chunk`, req);
  }

  mergeChunk(req) {
    return this.post(`${MESSAGE}/merge-chunk`, req);
  }

  sendFile(req, signal) {
    return this.post(`${MESSAGE}/send-file`, req, { signal });
  }

  pinnedMessage(request) {
    return this.post(`${MESSAGE}/conversation/pinned-message`, request);
  }

  promotePinnedMessage(request) {
    return this.post(`${MESSAGE}/conversation/promote-pinned-message`, request);
  }

  getPinnedMessage(param) {
    return this.post(
      `${MESSAGE}/conversation/get-pinned-message/${param?.conversationId}`,
    );
  }

  getMessageById(param) {
    return this.post(`${MESSAGE}/detail`, param);
  }

  createVoteMessage(params) {
    return this.post(`${MESSAGE}/create-message-vote`, params);
  }

  getVoteMessage(params) {
    return this.post(`${MESSAGE}/get-message-vote`, params);
  }

  getFirstMessageUnread(params) {
    return this.post(`${MESSAGE}/first-message-unread`, params);
  }

  haveNewMessage(conversationId, signal) {
    return this.get(`${MESSAGE}/have-new-message`, { conversationId }, signal);
  }
}

export default MessageApi;
